import {
  Functions,
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from "firebase/functions";

export interface CuotapartistaRequest {
  cuit: string;
  legalName: string;
  representative: string;
  email: string;
  referrer: string;
  /** Empty until the backend exposes the endpoint that returns it */
  accountNumber?: string;
}

let functions: Functions | null = null;

// Lazily resolved so we never touch Firebase before main.tsx initializes it
const getFunctionsInstance = () => {
  if (!functions) {
    functions = getFunctions();

    // Local development against the emulator (`npm --prefix functions run serve`)
    if (import.meta.env.VITE_FUNCTIONS_EMULATOR === "true") {
      connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    }
  }

  return functions;
};

/**
 * Appends the company data to the Allaria Fondos spreadsheet when a company
 * that already has an Allaria account requests the "cuotapartista" opening.
 */
export const sendCuotapartistaRequest = (data: CuotapartistaRequest) =>
  httpsCallable<CuotapartistaRequest, { ok: boolean }>(
    getFunctionsInstance(),
    "appendCuotapartistaRequest",
  )(data);
